export default __webpack_public_path__ + "static/media/question_doodle.241148b6.png";